import React from 'react';
import { SpriteSvg } from 'project/sprite-svg';
import { deviceTypes } from './enums';

class QualDrawSearchInput extends React.Component {
    constructor(props) {
        super(props);

        this.inputRef = React.createRef();

        this.searchBehaviorState = true;

        this.state = {
            animationState: false,
            clearValueSearchInput: false,
            defaultSearchValue: ''
        };
    }

    renderIcon = () => {
        if (!this.state.clearValueSearchInput) {
            return <SpriteSvg
                childCss="qual-draw__search-icon"
                iconName="search"
                width="18"
                height="18"
            />;
        }

        return <SpriteSvg
            childCss="qual-draw__search-close-icon"
            iconName="cross"
            width="10"
            height="10"
        />;
    }

    searchBehavior = (event, callback) => {
        if (this.state.defaultSearchValue === '') {
            this.setState({ clearValueSearchInput: true });
        }

        if (this.state.clearValueSearchInput) {
            callback('');
            this.setState({
                clearValueSearchInput: false,
                defaultSearchValue: ''
            });
            return false;
        }

        callback(this.state.defaultSearchValue);
        this.setState({ clearValueSearchInput: true });

        return true;
    }

    handleKeyPress = (event, callback) => {
        if (event.key !== 'Enter') return false;
        this.searchBehavior(event, callback);
        return true;
    }

    searchMobileBehavior = () => {
        if (this.searchBehaviorState &&
            this.props.deviceTypeByViewport === deviceTypes.MOBILE) {
            this.setState({ animationState: true });

            window.setTimeout(() => {
                this.inputRef.current.focus();
            }, 300);

            this.searchBehaviorState = false;

            return false;
        }

        if (this.state.clearValueSearchInput) {
            this.setState({ animationState: false });
            this.searchBehaviorState = true;
        }

        if (this.searchBehaviorState &&
            this.props.deviceTypeByViewport !== deviceTypes.MOBILE) {
            this.searchBehaviorState = false;
        }

        return true;
    }

    startSearchBehavior = (event, callback) => {
        this.searchBehavior(event, callback);
        this.searchMobileBehavior();
    }

    renderAnimationState = () => {
        let isActive = '';

        if (this.props.deviceTypeByViewport !== deviceTypes.MOBILE) {
            isActive = 'is-active';
        }

        if (this.state.animationState &&
            this.props.deviceTypeByViewport === deviceTypes.MOBILE) {
            isActive = 'is-active';
        }

        return isActive;
    }

    handleSearch = (event) => {
        if (this.state.clearValueSearchInput) {
            this.setState({ clearValueSearchInput: false });
        }

        this.setState({
            defaultSearchValue: event.target.value,
        });
    }

    render() {
        if (this.props.deviceTypeByViewport !== deviceTypes.MOBILE) {
            this.searchBehaviorState = true;
        }

        return (
            <div className={`qual-draw__search
                ${this.state.clearValueSearchInput ? 'is-close' : ''}
                ${this.renderAnimationState()}`}>

                <input
                    className={'qual-draw__search-input'}
                    type="text"
                    value={this.state.defaultSearchValue}
                    placeholder="Player name"
                    ref={this.inputRef}
                    onChange={(event) => this.handleSearch(event)}
                    onKeyPress={(event) => this.handleKeyPress(event, this.props.defaultCallback)}
                />

                <button
                    className="qual-draw__search-button"
                    type="button"
                    onClick={(event) => this.startSearchBehavior(event, this.props.defaultCallback)}
                >
                    <div className="qual-draw__search-button-container">
                        {this.renderIcon()}
                    </div>
                </button>
            </div>
        );
    }
}

export default QualDrawSearchInput;
